export default function ($translateProvider) {
    $translateProvider.translations('en', require('./en'));
    $translateProvider.translations('es', require('./es'));
    $translateProvider.translations('ca', require('./ca'));


    $translateProvider.useSanitizeValueStrategy(null);

    $translateProvider.registerAvailableLanguageKeys(['en', 'es', 'ca']);
    $translateProvider.preferredLanguage('es');
};


/** WEBPACK FOOTER **
 ** ./js/languages/languages.js
 **/